/**
 * Behavior for the Tuang Immersive section (sections/tuang-immersive.liquid):
 * scroll-reveal/count-up and pointer parallax/tilt/magnetic-CTA. Each
 * concern returns cleanup callbacks so shopify:section:unload (fired by
 * the Theme Editor when a section re-renders after a setting change) can
 * tear everything down instead of leaking observers/listeners. The mesh/
 * grain/bean-canvas backdrop this section used to render itself now lives
 * site-wide in assets/tng-backdrop.js.
 */
(function () {
  'use strict';

  var registry = new WeakMap();

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function countUp(el) {
    var b = el.querySelector('b[data-count]');
    if (!b || b.dataset.done) return;
    b.dataset.done = '1';
    var target = parseFloat(b.dataset.count) || 0;
    var plain = b.dataset.plain === '1';
    var suffix = b.dataset.suffix || '';
    var start = null;
    var duration = 1400;
    function step(t) {
      if (!start) start = t;
      var p = Math.min((t - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var v = Math.round(target * eased);
      b.textContent = (plain ? v : v.toLocaleString('en-US')) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initReveal(root, reduce, cleanupFns) {
    var items = root.querySelectorAll('[data-reveal]');

    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var t = setTimeout(function () { el.classList.add('is-in'); }, el.dataset.d || 0);
          cleanupFns.push(function () { clearTimeout(t); });
          if (el.classList.contains('tng-stat')) countUp(el);
          io.unobserve(el);
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
      items.forEach(function (el, i) { el.dataset.d = (i % 4) * 80; io.observe(el); });
      cleanupFns.push(function () { io.disconnect(); });
    } else {
      items.forEach(function (el) {
        el.classList.add('is-in');
        if (el.classList.contains('tng-stat')) countUp(el);
      });
    }
  }

  function initPointerEffects(root, cleanupFns) {
    var cards = root.querySelectorAll('[data-tilt]');
    var mags = root.querySelectorAll('[data-magnetic]');

    cards.forEach(function (card) {
      function onMove(ev) {
        var r = card.getBoundingClientRect();
        var px = (ev.clientX - r.left) / r.width - 0.5;
        var py = (ev.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'perspective(700px) rotateY(' + (px * 9) + 'deg) rotateX(' + (-py * 9) + 'deg) translateY(-6px)';
      }
      function onLeave() { card.style.transform = ''; }
      card.addEventListener('pointermove', onMove);
      card.addEventListener('pointerleave', onLeave);
    });

    mags.forEach(function (btn) {
      function onMove(ev) {
        var r = btn.getBoundingClientRect();
        btn.style.transform = 'translate(' + ((ev.clientX - r.left - r.width / 2) * 0.28) + 'px,' + ((ev.clientY - r.top - r.height / 2) * 0.4) + 'px)';
      }
      function onLeave() { btn.style.transform = ''; }
      btn.addEventListener('pointermove', onMove);
      btn.addEventListener('pointerleave', onLeave);
    });
  }

  function initRoot(root) {
    if (registry.has(root)) return;
    var reduce = prefersReducedMotion();
    var cleanupFns = [];
    initReveal(root, reduce, cleanupFns);
    if (!reduce) {
      initPointerEffects(root, cleanupFns);
    }
    registry.set(root, function cleanup() {
      cleanupFns.forEach(function (fn) { fn(); });
      registry.delete(root);
    });
  }

  function destroyRoot(root) {
    var cleanup = registry.get(root);
    if (cleanup) cleanup();
  }

  function scan(node) {
    if (!node || !node.querySelectorAll) return;
    var roots = node.matches && node.matches('[data-tng-exp]') ? [node] : [];
    roots = roots.concat(Array.prototype.slice.call(node.querySelectorAll('[data-tng-exp]')));
    roots.forEach(initRoot);
  }
  function destroyIn(node) {
    if (!node || !node.querySelectorAll) return;
    if (node.matches && node.matches('[data-tng-exp]')) destroyRoot(node);
    node.querySelectorAll('[data-tng-exp]').forEach(destroyRoot);
  }

  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { destroyIn(event.target); });

  scan(document);
})();
